import { render, staticRenderFns } from "./SalesInvoiceListTable.vue?vue&type=template&id=53376554"
import script from "./SalesInvoiceListTable.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports